import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import useSound from "use-sound";

import successSound from "../assets/sounds/success.mp3";
import errorSound from "../assets/sounds/error.mp3";
import loginSound from "../assets/sounds/login.mp3";
import logoutSound from "../assets/sounds/logout.mp3";
import deactivateSound from "../assets/sounds/deactivate.mp3";

const icons = {
  success: "✅",
  error: "❌",
  login: "🔐",
  logout: "🔒",
  deactivate: "🚫",
};

export function useNotification() {
  const [soundEnabled, setSoundEnabled] = useState(true);

  const [playSuccess] = useSound(successSound, { volume: 0.5, soundEnabled });
  const [playError] = useSound(errorSound, { volume: 0.5, soundEnabled });
  const [playLogin] = useSound(loginSound, { volume: 0.9, soundEnabled });
  const [playLogout] = useSound(logoutSound, { volume: 0.9, soundEnabled });
  const [playDeactivate] = useSound(deactivateSound, { volume: 0.5, soundEnabled });

  const notify = useCallback(
    ({ type = "info", message = "", playSound = () => {}, style = {} }) => {
      try {
        playSound();
      } catch (err) {
        console.warn(`🔇 Erro ao tocar som (${type}):`, err);
      }

      toast[type](message, {
        position: "top-right",
        icon: icons[type] || "ℹ️",
        style: {
          ...style,
        },
      });
    },
    []
  );

  const notifySuccess = useCallback(
    (message = "Operação realizada com sucesso!") =>
      notify({
        type: "success",
        message,
        playSound: playSuccess,
        style: {
          backgroundColor: "green",
          color: "white",
        },
      }),
    [notify, playSuccess]
  );

  const notifyError = useCallback(
    (message = "Ocorreu um erro.") =>
      notify({
        type: "error",
        message,
        playSound: playError,
        style: {
          backgroundColor: "red",
          color: "white",
        },
      }),
    [notify, playError]
  );

  const notifyLogin = useCallback(
    (message = "Login efetuado com sucesso!") =>
      notify({
        type: "success",
        message,
        playSound: playLogin,
        style: {
          backgroundColor: "#0077cc",
          color: "white",
        },
        icon: icons.login,
      }),
    [notify, playLogin]
  );

  const notifyLogout = useCallback(
    (message = "Sessão terminada com sucesso.") =>
      notify({
        type: "info",
        message,
        playSound: playLogout,
        style: {
          backgroundColor: "#444",
          color: "white",
        },
        icon: icons.logout,
      }),
    [notify, playLogout]
  );

  const notifyDeactivate = useCallback(
    (message = "Aluno desativado com sucesso!") =>
      notify({
        type: "info",
        message,
        playSound: playDeactivate,
        style: {
          backgroundColor: "#444",
          color: "white",
        },
        icon: icons.deactivate,
      }),
    [notify, playDeactivate]
  );

  const toggleSound = () => setSoundEnabled((enabled) => !enabled);

  return {
    notifySuccess,
    notifyError,
    notifyLogin,
    notifyLogout,
    notifyDeactivate,
    soundEnabled,
    toggleSound,
  };
}
